import { AxiosInstance } from "axios";

export const ConfirmServices = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlUser = "api/user";
  const apiBaseUrlAgenda = "api/agenda";
  return {
    getdatauserByagendaid: async (user: string | null) => {
      return await axiosInstance
        .get(`${apiBaseUrlUser}/${user}`)
        .then((result) => result.data);
    },
    getdataagendaByagendaid: async (agenda: string | null) => {
      return await axiosInstance
        .get(`${apiBaseUrlAgenda}/${agenda}`)
        .then((result) => result.data);
    },
    confirmEvent: async (body: any) => {
      return await axiosInstance
        .post(`${apiBaseUrlUser}/confirmEvent`, body)
        .then((result) => result.data);
    },
  };
};
